import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { CompanySettingsProvider } from '@/context/CompanySettingsContext';
import Layout from '@/components/Layout';
import Dashboard from '@/pages/Dashboard';
import DataCapture from '@/pages/DataCapture';
import GHGInventory from '@/pages/GHGInventory';
import Benchmarking from '@/pages/Benchmarking';
import FrameworkMapping from '@/pages/FrameworkMapping';
import ESGRisks from '@/pages/ESGRisks';
import TargetSetting from '@/pages/TargetSetting';
import MaterialityAssessment from '@/pages/MaterialityAssessment';
import SDGMapping from '@/pages/SDGMapping';
import ComplianceReadiness from '@/pages/ComplianceReadiness';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <CompanySettingsProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/data-capture" element={<DataCapture />} />
              <Route path="/ghg-inventory" element={<GHGInventory />} />
              <Route path="/benchmarking" element={<Benchmarking />} />
              <Route path="/framework-mapping" element={<FrameworkMapping />} />
              <Route path="/esg-risks" element={<ESGRisks />} />
              <Route path="/targets" element={<TargetSetting />} />
              <Route path="/materiality" element={<MaterialityAssessment />} />
              <Route path="/sdg-mapping" element={<SDGMapping />} />
              <Route path="/compliance" element={<ComplianceReadiness />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </CompanySettingsProvider>
    </div>
  );
}

export default App;
